module.exports = __webpack_public_path__ + "static/media/Pajoohyar.527f2a39.png";